import React, { useContext, useEffect, useState } from 'react';
import { StyledUserInfoContainer, StyledUserInfoWrapper, StyledUserInfo, StyledWalletInfo, StyledButtonWrapper, StyledUserProfileImage } from './UserInfo.styled';
import PlusImage from "../../../assets/images/plus.svg"
import RandomImage from "../../../assets/images/random.svg"
import PublicImage from "../../../assets/images/eye.png"
import ProfileImage from "../../../assets/images/profile.png"
import Input from '../../Input/Input';
import Button from '../../Button/Button';
import { PlayerContext } from '../../../contexts/playerContext';

interface Props {
    setActive: (active: string) => void
}

const UserInfo = (props: Props) => {
    const playerContext = useContext(PlayerContext);
    const [createdAt, setCreatedAt] = useState<string>("---");

    useEffect (() => {
        if(playerContext?.createdAt == undefined) {
            return;
        }
        const month = playerContext?.createdAt.toLocaleString('en-US', { month: 'long' });
        const year = playerContext?.createdAt.getFullYear();
        setCreatedAt(`Member since ${month} ${year}`)
    }, [playerContext?.createdAt])
    const handleAddFunc = () => {
    }

    return (
        <StyledUserInfoContainer>
            <StyledUserInfoWrapper>
                <div style={{ width: '150px', height: '150px' }}>
                    <StyledUserProfileImage src={playerContext?.avatar == "" ? ProfileImage : `${process.env.REACT_APP_API_ENDPOINT}${playerContext?.avatar}`} crossOrigin="anonymous" alt="profile image" />
                </div>
                <StyledUserInfo>
                    <h2 style={{ color: 'white', fontSize: '1.5rem', lineHeight: '2rem', margin: '0', fontWeight: '400' }}>{playerContext?.userShorWallet}</h2>
                    <h5 style={{ color: 'white', opacity: '0.5', fontSize: '12px', lineHeight: '1rem', margin: '0', fontWeight: '400' }}>{createdAt}</h5>
                    <StyledWalletInfo>
                        <div>
                            <h5 style={{ color: 'white', opacity: '0.5', fontSize: '12px', lineHeight: '1rem', margin: '0', fontWeight: '400' }}>Balance</h5>
                            {/* <h2 style={{ color: 'white', fontSize: '1rem', lineHeight: '1.5rem', margin: '0', fontWeight: '400' }}>{balance} SOL</h2> */}
                        </div>
                        <StyledButtonWrapper>
                            <Button padding='1rem' textSize='12px' text='Add Fund' image={PlusImage} size='small' event={() => props.setActive("active")} />
                        </StyledButtonWrapper>
                    </StyledWalletInfo>
                </StyledUserInfo>
            </StyledUserInfoWrapper>
        </StyledUserInfoContainer>
    );
}

export default UserInfo;
